import { BaseColumnFormatter } from "./BaseColumnFormatter";

export class EnumFormatter extends BaseColumnFormatter
{
    constructor(width: string = "125px")
    {
        super();
        this.width = width;
    }
    override format(value: any): any
    {
        return value;
    }
}